import Utility from "../utilities/utility";

const baseUrl = process.env.REACT_APP_BASE_URL;

class PaymentService{


    addPayment(entityId, supplierId, description, amount, countryId, type){


        const reqData = {
            "entityId": entityId,
            "supplierId": supplierId,
            "description": description,
            "amount" : amount,
            "originCountryId": countryId,
            "type": type

        }; 

        const token = localStorage.getItem('token');
        

        return fetch(baseUrl+'/admin/payment/add', {
            method : 'POST',
            headers: {
                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            },
            body: JSON.stringify(reqData)
        })
            
        .catch(error => console.log(error))
    }



    paymentList(countryId, supplierId, fromDate, toDate){


        const reqData = {
            "countryId": countryId,
            "supplierId": supplierId,
            "fromDate": fromDate,
            "toDate" : toDate

        }; 
        const token = localStorage.getItem('token');
        

        return fetch(baseUrl+'/admin/payment/list', {
            method : 'POST',
            headers: {
                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            },
            body: JSON.stringify(reqData)
        });
            
        
    }


    removePayment(paymentId){


        if(Utility.isEmpty(paymentId)){

            throw new Error('Payment id missing');
        }

        const token = localStorage.getItem('token');
        

        return fetch(baseUrl+'/admin/payment/remove/'+paymentId, {
            method : 'DELETE',
            headers: {
                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            }
        });
            
        
    }



}

export default PaymentService;